const Profile = () => <div>Profile</div>

export default Profile
